<ng-container [ngSwitch]="template">
  <ng-container *ngSwitchCase="'default'">
    <ng-container *ngTemplateOutlet="tplDefault"></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'claim'">
    <ng-container *ngTemplateOutlet="tplClaim"></ng-container>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <ng-container *ngTemplateOutlet="tplDefault"></ng-container>
  </ng-container>
</ng-container>

<ng-template #tplDefault>
  <div class="default">
    <div class="bordered mt-2">
      <div class="files-group">
        <div class="file" *ngFor="let file of files; trackBy: trackByFile">
          <input #fileReplace hidden type="file" class="hidden" [accept]="accept" (change)="onReplaceFile(file,$event)"
            (click)="onFileInputClick($event)"/>
          <mat-icon>attach_file</mat-icon>
          <span class="file-name">{{truncateFilename(file.name ?? '', 13)}}</span>
          <button type="button" class="action-button" [matMenuTriggerFor]="menu" aria-label="File actions">
            <mat-icon class="action-icon" color="accent">more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu" class="actions">
            <button *ngIf="isViewAvailable(file)" type="button" mat-menu-item (click)="onOpenFile(file)">
              Open file
            </button>
            <button *ngIf="!isViewOnly && !file.editBlocked" type="button" mat-menu-item (click)="fileReplace.click()">
              Replace file
            </button>
            <button *ngIf="!isViewOnly && !file.editBlocked" type="button" mat-menu-item (click)="onDeleteFile(file)">
              Delete file
            </button>
          </mat-menu>
        </div>
      </div>
    
      <div class="drop-clue" appDragDrop (fileDropped)="onDragAndDropFile($event)">
        <mat-icon color="accent">backup</mat-icon>
        <p>Drop your files here</p>
      </div>
    </div>
    
    <div class="drop-outer mt-3 center-align" *ngIf="!isViewOnly">
      <p>{{textUnderDropZone}}</p>
      <div class='button-container'>
        <button class="browse-file">Browse Files</button>
        <input type='file' multiple [accept]="accept" (change)="onFileInputChange($event)"
          (click)="onFileInputClick($event)"/>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #tplClaim>
  <div class="claim mt-3">
    <div class="drop-clue-claim" appDragDrop (fileDropped)="onDragAndDropFile($event)">
      <div class="drag-drop-desc">
        <mat-icon color="accent">backup</mat-icon>
        <p>Drop your files here</p>
      </div>
    </div>
    <p>
      {{textUnderDropZone}}
      <span> *</span>
    </p>
    <div class="file-input-row mt-2 mb-2">
      <div class="bordered-claim">
        <div class="files-group-claim">
          <div class="no-files" [hidden]="files?.length">
            No Files
          </div>
          <div class="file" *ngFor="let file of files; trackBy: trackByFile">
            <input #fileReplace hidden type="file" class="hidden" [accept]="accept" (change)="onReplaceFile(file,$event)"
              (click)="onFileInputClick($event)"/>
            <mat-icon>attach_file</mat-icon>
            <span class="file-name">{{truncateFilename(file.name ?? '', 13)}}</span>
            <button type="button" class="action-button" [matMenuTriggerFor]="menu" aria-label="File actions">
              <mat-icon class="action-icon" color="accent">more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu" class="actions">
              <button *ngIf="isViewAvailable(file)" type="button" mat-menu-item (click)="onOpenFile(file)">
                Open file
              </button>
              <button *ngIf="!isViewOnly && !file.editBlocked" type="button" mat-menu-item (click)="fileReplace.click()">
                Replace file
              </button>
              <button *ngIf="!isViewOnly && !file.editBlocked" type="button" mat-menu-item (click)="onDeleteFile(file)">
                Delete file
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
    
      <div class="drop-outer-zone button-container">
          <button class="browse-file-claim">Upload</button>
          <input type='file' multiple [accept]="accept" (change)="onFileInputChange($event)"
            (click)="onFileInputClick($event)"/>
      </div>
    </div>
  </div>
</ng-template>
